module.exports = __webpack_public_path__ + "img/file-earmark-minus.e507f587.svg";